<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-4">
          Roles
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-6 col-md-2 padding-right-0px text-align-right">
              <a (click)="AddNewRole()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Role"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                </div>
                <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="">
                      Name
                    </th>

                    <th class="">
                      Description
                    </th>

                    <th class="">
                      Status
                    </th>
                    <th class="">

                    </th>

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr>

                    <td class=" td-padding-tb">Nursing</td>
                    <td class="td-padding-tb">Nursing</td>
                    <td class="td-padding-tb ">A</td>
                    <td class=" td-padding-tb ">
                      <button (click)="EditRol()" type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                      <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                    </td>

                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="NewRole">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Role"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Add New Role
        </div>
      </div>      

    </div>
    <div class="card-body padding-top-0px">

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Role
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Name"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Description</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Description"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Status</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="EditRole">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Role"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Edit Role
        </div>
      </div>      

    </div>
    <div class="card-body padding-top-0px">

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Role
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Name"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Description</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Description"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Status</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

</div>

<!--<div class="col-md-12" *ngIf="!ShowList">

  <profileview (GoBack)="OnGoBack()"
               [FormattedCode]="SelectedPatient.FormattedCode" [DisplayName]="SelectedPatient.DisplayName" *ngIf="ShowPatientDetails"></profileview>
</div>-->

